export function checkUserLogin(data){
    return dispatch => {
        dispatch({
            type: "CHECK_CREDENTIALS",
            payload: data
        });
    }
}